import { render, staticRenderFns } from "./ProjectTaskDetail.vue?vue&type=template&id=dafeae98"
import script from "./ProjectTaskDetail.vue?vue&type=script&lang=js"
export * from "./ProjectTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports